module.exports = __webpack_public_path__ + "img/comments-question-check.27232249.svg";